export const errorMessage = (err, fallback) => err.response?.data?.error || err.message || fallback;
